"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchShippingAddress = exports.setManualAddressMode = exports.resetVerification = exports.resetShipping = exports.resetErrors = exports.resetError = exports.validateShipping = void 0;

var _reduxAct = require("redux-act");

var _utils = require("@alycecom/utils");

var prefix = 'GIFT_CREATE/SHIPPING';
var validateShipping = (0, _utils.createAsyncAction)("".concat(prefix, "/VALIDATE1"));
exports.validateShipping = validateShipping;
var resetError = (0, _reduxAct.createAction)("".concat(prefix, "/RESET_ERROR"));
exports.resetError = resetError;
var resetErrors = (0, _reduxAct.createAction)("".concat(prefix, "/RESET_ERRORS"));
exports.resetErrors = resetErrors;
var resetShipping = (0, _reduxAct.createAction)("".concat(prefix, "/RESET_SHIPPING"));
exports.resetShipping = resetShipping;
var resetVerification = (0, _reduxAct.createAction)("".concat(prefix, "/RESET_VERIFICATION"));
exports.resetVerification = resetVerification;
var setManualAddressMode = (0, _reduxAct.createAction)("".concat(prefix, "/SET_MANUAL_ADDRESS_MODE"));
exports.setManualAddressMode = setManualAddressMode;
var fetchShippingAddress = (0, _utils.createAsyncAction)("".concat(prefix, "/FETCH_SHIPPING_ADDRESS"));
exports.fetchShippingAddress = fetchShippingAddress;